<!--
* 组件名 : 右侧logo和底部菜单
* 开发者 : HN
*
* 参数:  无
*
* 事件:  null
*
-->
<template>
  <div class="menu-left">
    <a class="menu-logo" @click="$router.push('/')">
      <v-img path="common/logo.svg" :alt="logo.alt" />
      <h1 hidden>{{ logo.alt }}</h1>
    </a>
    <div class="menu-footer" ref="menuFooter" v-html="asideMoreInfo"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "menu-left",
  computed: {
    ...mapGetters("global", ["asideMoreInfo", "logo"]),
  },
  mounted() {
    this.copyright_handle();
    this.link_add_target_blank();
  },
  methods: {
    ...mapMutations("global", ["updateIsCopyrightShow"]),
    /**
     * 点击版权署名页面
     */
    copyright_handle() {
      this.$nextTick(() => {
        $(this.$refs.menuFooter).on("click", "a", (ev) => {
          if (
            ev.currentTarget.dataset.slug &&
            ev.currentTarget.dataset.slug === "copyright"
          ) {
            this.updateIsCopyrightShow(true);
          }
        });
      });
    },
    /**
     * 链接添加新开窗口打开
     */
    link_add_target_blank() {
      $(this.$refs.menuFooter)
        .find("li a")
        .map((i, item) => {
          if (!item.getAttribute("data-slug")) {
            item.setAttribute("target", "_blank");
          }
        });
    },
  },
};
</script>

<style lang="scss">
#menu {
  .menu-container {
    .menu-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;

      width: 344px;
      max-width: 344px;
      margin-right: 64px;
      opacity: 0;
      transform: translateX(-1vw);
      transition: all 500ms cubic-bezier(0.645, 0.045, 0.355, 1);
      transition-delay: 50ms;

      .menu-logo {
        display: block;
        margin-top: 40px;
        width: 250px;
        cursor: pointer;
        img {
          width: auto;
        }
      }
      .menu-footer {
        margin-bottom: 36px;

        color: #f5f5f5;
        font-size: 14px;
        text-align: right;
        ul {
          display: flex;
          margin-bottom: 12px;
        }
        li {
          position: relative;
          display: inline-block;
          margin-right: 24px;

          &:last-of-type {
            margin-right: 0;
          }
        }
        p {
          text-indent: 0;
        }
        a {
          font-size: 14px;
          transition: color $base-duration cubic-bezier(0.645, 0.045, 0.355, 1);
          text-decoration: none;
          color: #f5f5f5;
          &:hover {
            text-decoration: underline;
            color: $color-navigation;
          }
        }
      }
    }
  }

  @media (max-width: $lx-min) {
    .menu-container {
      .menu-left {
        margin-right: 32px;
      }
    }
  }
}
</style>
